import { useRef, useState } from 'react';
import CreateInvoiceHeader from './createInvoiceHeader';
import { getCurrentDate } from '../../../../../utils/dateUtils';
import InvoiceForm from './invoiceForm';

const CreateInvoice = () => {
	const [error, setError] = useState({});
	const [tableError, setTableError] = useState([]);
	const tableRef = useRef(null);

	const [additionDiscountAndTax, setAdditionDiscountAndTax] = useState({
		discount: null,
		adj: null,
		round_off: null,
	});
	const [invoice, setInvoice] = useState({
		customer_id: null,
		doctor_id: null,
		invoice_number: '',
		date: getCurrentDate(),
		sale_order_id: null,
		remark: '',
		payment_method: null,
		due_date: getCurrentDate(),
	});
	const [invoiceTable, setInvoiceTable] = useState([]);

	function totalDiscountAmount() {
		let amount =
			invoiceTable.length > 0
				? invoiceTable?.reduce((sum, item) => Number(sum) + Number(item.amount), 0)
				: 0;
		let totalDiscount = (amount * Number(additionDiscountAndTax.discount ?? 0)) / 100;
		return totalDiscount;
	}
	function totalTaxesAmount() {
		let totalTax1 =
			invoiceTable.length > 0
				? invoiceTable?.reduce(
						(sum, item) =>
							Number(sum) + (Number(item.amount ?? 0) * Number(item.product_tax1 ?? 0)) / 100,
						0,
					)
				: 0;
		let totalTax2 =
			invoiceTable.length > 0
				? invoiceTable?.reduce(
						(sum, item) =>
							Number(sum) + (Number(item.amount ?? 0) * Number(item.product_tax2 ?? 0)) / 100,
						0,
					)
				: 0;
		return Number(totalTax1) + Number(totalTax2);
	}
	function totalAmount() {
		let amount =
			invoiceTable.length > 0
				? invoiceTable?.reduce((sum, item) => Number(sum) + Number(item.amount), 0)
				: 0;
		let totalTaxes = totalTaxesAmount();
		let totalAmountWithDiscount =
			amount - (amount * Number(additionDiscountAndTax.discount ?? 0)) / 100;
		let totalAmountWithTax = Number(totalAmountWithDiscount) + Number(totalTaxes);
		// console.log(amount);
		// console.log(totalTaxes);
		// console.log(totalAmountWithDiscount);
		return (
			Number(totalAmountWithTax) -
			Number(additionDiscountAndTax.adj ?? 0) -
			Number(additionDiscountAndTax.round_off ?? 0)
		);
	}
	const calculateAmount = () => {
		return invoiceTable.length > 0
			? invoiceTable?.reduce((sum, item) => Number(sum) + Number(item.amount), 0)
			: 0;
	};

	console.log(additionDiscountAndTax.discount);
	return (
		<div>
			<div className="">
				<CreateInvoiceHeader
					totalDiscountAmount={totalDiscountAmount}
					totalTaxesAmount={totalTaxesAmount}
					totalAmount={totalAmount}
					calculateAmount={calculateAmount}
					additionDiscountAndTax={additionDiscountAndTax}
					error={error}
					setError={setError}
					tableError={tableError}
					setTableError={setTableError}
					invoice={invoice}
					invoiceTable={invoiceTable}
				/>
				<InvoiceForm
					setInvoice={setInvoice}
					invoice={invoice}
					error={error}
					setError={setError}
					setInvoiceTable={setInvoiceTable}
					setAdditionDiscountAndTax={setAdditionDiscountAndTax}
					tableRef={tableRef}
					invoiceTable={invoiceTable}
					tableError={tableError}
					setTableError={setTableError}
					additionDiscountAndTax={additionDiscountAndTax}
					totalDiscountAmount={totalDiscountAmount}
					totalTaxesAmount={totalTaxesAmount}
					totalAmount={totalAmount}
					calculateAmount={calculateAmount}
				/>
			</div>
		</div>
	);
};
export default CreateInvoice;
